'use strict';
import { trackAction } from 'helpers/trackingOM';

export default class SearchSubNav {
    constructor() {
        this.currentCategory = null;
        this.searchFilterInView = [];
        this.searchIdInView = [];
        this.__initNavButtons();
        this.__setUpNavButtonsListeners();
    }

    __initNavButtons() {
        const self = this;
        self.buttons = document.querySelectorAll('.subnav__items a');

        self.buttons.forEach((anchor, index) => {
            const anchorText = anchor.textContent.trim() ?? '';
            const anchorId = anchor.dataset.gid ?? '';
            // tracking
            self.searchFilterInView.push(anchorText);
            self.searchIdInView.push(anchorId);
        });
    }

    __setUpNavButtonsListeners() {
        $(this.buttons).on('click', (e) => {
            const btn = $(e.target);
            this.category = btn.data('category') ?? [];

            const element = $(e.currentTarget)[0];
            const columnPos = $(element).parent().prevAll('li').length.toString();
            const itemLabel = this.category
                ? `Presearch-${this.category[0].toUpperCase() + this.category.slice(1)}`
                : 'Presearch';

            if (this.category === this.currentCategory) {
                trackAction('trackSuggestionDeselect', {
                    menuItemLabel: itemLabel,
                    posRowNum: '0',
                    posColNum: columnPos,
                    menuOrientation: 'header',
                    pageName: 'search',
                    pageType: 'search',
                    suggestedSearchTerm: this.category,
                    searchFilterInView:
                        CBS.Registry?.user?.profile_type?.toUpperCase() === 'ADULT'
                            ? this.searchFilterInView
                            : '',
                    searchIdInView: this.searchIdInView,
                });
                this.currentCategory = null;
            } else {
                trackAction('trackSuggestedSearchResultUsed', {
                    menuItemLabel: itemLabel,
                    posRowNum: '0',
                    posColNum: columnPos,
                    menuOrientation: 'header',
                    pageName: 'search',
                    pageType: 'search',
                    searchResultListing: '1',
                    suggestedSearchTerm: this.category,
                    searchFilterInView:
                        CBS.Registry?.user?.profile_type?.toUpperCase() === 'ADULT'
                            ? this.searchFilterInView
                            : '',
                    searchIdInView: this.searchIdInView,
                });
                this.currentCategory = this.category;
            }

            if (typeof searchDefault !== 'undefined' && searchDefault) {
                om.trackState({
                    //TODO: UPDATE TRACKING VALUES
                    hubId: __hub.id ?? utag_data.hubId,
                    hubSlug: __hub.hubSlug ?? utag_data.hubSlug,
                    hubPageType: __hub.hubPageType ?? utag_data.hubPageType,
                    pageName: collectionPageName ?? utag_data.pageName,
                    pageType: __hub.pageType ?? utag_data.pageType,
                });
            }
        });
    }
}
